import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import TabsWithTablesLayout from 'src/components/Layout/TabsWithTablesLayout';
import { useTenantContext } from 'src/context/useTenantContext';

interface EmployeesPageProps {}

const EmployeesPage = React.memo((_: EmployeesPageProps) => {
  const { t } = useTranslation();
  const { buildPath } = useTenantContext();
  const routes = [
    {
      label: t('common.employees'),
      url: buildPath('employees/all'),
    },
    {
      label: t('common.employeeIssues'),
      url: buildPath('employees/issues'),
    },
    {
      label: t('common.timesheets'),
      url: buildPath('employees/timesheets'),
    },
  ];
  return (
    <TabsWithTablesLayout routes={routes} title={t('common.employees')}>
      <Outlet />
    </TabsWithTablesLayout>
  );
});

export default EmployeesPage;
